import { render, staticRenderFns } from "./StartDateWorkshiftField.vue?vue&type=template&id=35367693&"
import script from "./StartDateWorkshiftField.vue?vue&type=script&lang=js&"
export * from "./StartDateWorkshiftField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports